export default __webpack_public_path__ + "static/media/Saral-Jeevan-Bima-Brochure.d1623d0e.pdf";